export default "__VITE_ASSET__0ec052e3__"